import { adminHttpClient } from '../commons/adminHttpClient'
import PagedList from '../commons/pagedList'
import { SearchEmailFilter, SearchEmailItemResponse } from '../csiDashboard/emailSearch/getEmails'

const getCompanyEmails = (filter: SearchEmailFilter): Promise<PagedList<SearchEmailItemResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'createdAt',
    orderDescending: false,
  }

  return adminHttpClient.get('/Companies/Emails', filter)
}

export default getCompanyEmails
